export default __webpack_public_path__ + "static/media/KeyPlan.29c67153.webp";